import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide2 from './slide_2.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide2 />
        </div>
        <div className={s.textWrapper}>
            <p>
                You define the skillset of the virtual experts, by the
                information you feed in to them, such as inputting human
                knowledge from your existing expert employees.
            </p>
            <p>
                <em>Here illustrated as building blocks.</em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide2.component.js